import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 8 15",
  "content": "<symbol viewBox=\"0 0 8 15\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-right\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.272461 14.3562L0.91626 15L8 7.91626L0.916261 0.832521L0.272462 1.47632L6.7124 7.91626L0.272461 14.3562Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol